export const attribute = (l10n = {}, it = {}, data = {}) => {
    const { isSkinType = false, isShowSpellList = false } = data;

    return `
    <section class="attribute">
        <header>
            <h3>${l10n['transformation.transformationInfo']}</h3>
            <button class="btn-folder is-active"></button>
        </header>
        <article class="is-active">
            <ul>
                ${!it.polymorphClassList?``:`
                <li>
                    <div class="key">${l10n['item.filter.class']}</div>
                    <div class="value">
                        ${it.polymorphClassList?.map(op => {
                            if (!op.name) return '';
                            return `<button data-detailshow="polymorph_${op.id}" data-itemgrade="${op.gradeId}" class="">${op.name}</button>`
                        }).join('<br>') || ''}
                    </div>
                </li>
                `}
                ${!isShowSpellList?``:`
                <li>
                    ${isSkinType?`
                    <div class="key">${l10n['transformation.skinspell']}</div>
                    `:`
                    <div class="key">${l10n['common.transformationSpell']}</div>
                    `}
                    <div class="value">
                        ${it.polymorphSpellList?.map(op => {
                            if (!op.name) return '';
                            return `<button data-detailshow="spell_${op.id}" data-itemgrade="${op.gradeId}" class="value">${op.name}</button>`
                        }).join('<br>') || ''}
                    </div>
                </li>
                `}
                ${!it.weaponTypeList?``:`
                <li>
                    <div class="key">${l10n['common.weaponType']}</div>
                    <div class="value">${it.weaponTypeList.map(we=>we.name).join(' / ')}</div>
                </li>
                `}
                ${!it.buffBonusList || it.buffBonusList.length<1?``:`
                <li>
                    <div class="key">${l10n['common.option']}</div>
                    <div class="value">
                        ${it.buffBonusList?.map(({ displayValue, extra }) => {
                            const extraBonusTmpl = extra ? ` <em> ${extra} </em>` : ``;
                            return `<p>${displayValue}${extraBonusTmpl}</p>`;
                        }).join('') || ''}
                    </div>
                </li>
                `}
            </ul>
        </article>
    </section>`;
};
